import { report } from 'report';
import { GameActions } from 'State/Game/GameActions';
import { LoadEvents, LoadEventType, LoadtimeTrackerSingleton } from 'Utility/LoadtimeTracker';
import { track } from 'Utility/Tracking/Track';
import { GBCHandler } from '../GBCHandler';

export function failedToConnectToGBC(error: unknown) {
    let gbError;
    try {
        gbError = GBCHandler.parseGBCError(error);
        track('gbError', gbError);
        LoadtimeTrackerSingleton.trackLoadTask(LoadEvents.GB_loginFlow, LoadEventType.End);
    } catch (error) {
        report('Failed to track gbc disconnection error', {
            error,
            once: true,
            sampleRate: 0.1,
            tags: {
                gbError,
            },
        });
    }
    GameActions.disconnectedFromGBC();
}
